import ReactCountryFlag from 'react-country-flag';

/**
 * Renders a flag icon component for a given country code using react-country-flag.
 *
 * This function converts a country code to uppercase and renders a ReactCountryFlag
 * component with a default height of 10px. The ReactCountryFlag component displays
 * a SVG flag image for the specified country.
 *
 * @param {string} countryCode - A two-letter ISO 3166-1 alpha-2 country code.
 * @returns {JSX.Element} A React component displaying the country's flag.
 *
 * @example
 * // In a React component:
 * return getFlagIcon('US'); // returns <ReactCountryFlag /> component with US flag
 * return getFlagIcon('JP'); // returns <ReactCountryFlag /> component with Japan flag
 *
 * // Usage in JSX:
 * <div>{getFlagIcon('GB')}</div>
 */
export const getFlagIcon = ({ countryCode, height = 10 }: { countryCode: string; height: number }) => (
  <ReactCountryFlag
    countryCode={countryCode.toUpperCase()}
    style={{
      boxShadow: '0 0 4px rgba(0, 0, 0, 0.2)',
      height,
      width: 'unset',
    }}
    svg
  />
);
